export interface QuestReward {
    xp: number;
    gold: number;
    items?: string[];
}

export type QuestStatus = 'locked' | 'available' | 'active' | 'completed';

export interface QuestObjective {
    id: string;
    description: string;
    type: 'collect' | 'talk' | 'kill' | 'explore';
    targetId: string; // Item name, NPC ID, Enemy type, or Location name
    targetCount: number;
    currentCount: number;
}

export interface Quest {
    id: string;
    title: string;
    description: string;
    objectives: QuestObjective[];
    status: QuestStatus;
    rewards: QuestReward;
    prereqQuestIds?: string[]; // IDs of quests that must be completed first
}

export const quests: Record<string, Quest> = {
    'collect_coin': {
        id: 'collect_coin',
        title: 'Golden Opportunity',
        description: 'The Guide asked you to find a Gold Coin.',
        status: 'available',
        rewards: { xp: 100, gold: 10 },
        objectives: [
            {
                id: 'obj_collect_coin',
                description: 'Collect 1 Gold Coin',
                type: 'collect',
                targetId: 'Gold Coin',
                targetCount: 1,
                currentCount: 0
            }
        ]
    },
    'talk_blacksmith': {
        id: 'talk_blacksmith',
        title: 'Meet the Smith',
        description: 'Go say hello to the Blacksmith near the Personal Projects house.',
        status: 'available',
        rewards: { xp: 50, gold: 0 },
        objectives: [
            {
                id: 'obj_talk_smith',
                description: 'Talk to Blacksmith',
                type: 'talk',
                targetId: 'Blacksmith',
                targetCount: 1,
                currentCount: 0
            }
        ]
    },
    'pest_control': {
        id: 'pest_control',
        title: 'Pest Control',
        description: 'The Farmer needs help clearing enemies from the Arena.',
        status: 'locked',
        prereqQuestIds: ['talk_blacksmith'],
        rewards: { xp: 200, gold: 50, items: ['Health Potion'] },
        objectives: [
            {
                id: 'obj_kill_enemies',
                description: 'Defeat 3 Enemies',
                type: 'kill',
                targetId: 'enemy',
                targetCount: 3,
                currentCount: 0
            }
        ]
    }
};
